import React from 'react';
import { ModalClose } from './modal-close.js';
import { ModalTitle } from './modal-title.js';
import './modal-header.css';
function renderModalClose(props) {
    const { onClose, showClose } = props;
    if (!showClose) {
        return null;
    }
    return (React.createElement(ModalClose, { onClick: onClose }));
}
function ModalHeader(props) {
    return (React.createElement("div", { className: "c-modal-header" },
        renderModalClose(props),
        React.createElement(ModalTitle, { id: props.id, value: props.title })));
}
export { ModalHeader, };
//# sourceMappingURL=modal-header.js.map